export default function Brand({ light = false }) {
  return <span className={`cf-brand${light ? ' cf-brand-light' : ''}`}>Clear<span>File</span></span>
}
